import { Suspense, lazy } from 'react';
import { PageLoader } from '@/shared/ui/loading/Loading';

const PeriodsPage = lazy(() => import('@/features/periods/PeriodsPage').then(m => ({ default: m.PeriodsPage })));
const DeductionsPage = lazy(() => import('@/features/deductions/DeductionsPage').then(m => ({ default: m.DeductionsPage })));
const ClassificationsPage = lazy(() => import('@/features/classifications/ClassificationsPage').then(m => ({ default: m.ClassificationsPage })));
const AnalysisGroupsPage = lazy(() => import('@/features/analysis-groups/AnalysisGroupsPage').then(m => ({ default: m.AnalysisGroupsPage })));
const AnalyticsPage = lazy(() => import('@/features/analytics/AnalyticsPage').then(m => ({ default: m.AnalyticsPage })));
const AuditPage = lazy(() => import('@/features/audit/AuditPage').then(m => ({ default: m.AuditPage })));
const CostCentersPage = lazy(() => import('@/features/cost-centers/CostCentersPage').then(m => ({ default: m.CostCentersPage })));
const BalancePage = lazy(() => import('@/features/balance/BalancePage').then(m => ({ default: m.BalancePage })));
const ClassifiedExpensePage = lazy(() => import('@/features/classified-expense/ClassifiedExpensePage').then(m => ({ default: m.ClassifiedExpensePage })));
const ConfigEstadoResultadoPage = lazy(() => import('@/features/config-estado-resultado/ConfigEstadoResultadoPage').then(m => ({ default: m.ConfigEstadoResultadoPage })));
const YearlyComparisonPage = lazy(() => import('@/features/yearly-comparison/YearlyComparisonPage').then(m => ({ default: m.YearlyComparisonPage })));
const CostosSubaplicadosPage = lazy(() => import('@/features/costos-subaplicados/CostosSubaplicadosPage').then(m => ({ default: m.CostosSubaplicadosPage })));
const MayorCuentasPage = lazy(() => import('@/features/mayor-cuentas/MayorCuentasPage').then(m => ({ default: m.MayorCuentasPage })));
const IntercompanyCuentasPage = lazy(() => import('@/features/intercompany-cuentas/IntercompanyCuentasPage').then(m => ({ default: m.IntercompanyCuentasPage })));

export function LazyWrapper({ children }: { children: React.ReactNode }) {
  return (
    <Suspense fallback={<PageLoader message="Cargando módulo..." />}>
      {children}
    </Suspense>
  );
}

export const lazyPages = {
  PeriodsPage,
  DeductionsPage,
  ClassificationsPage,
  AnalysisGroupsPage,
  AnalyticsPage,
  AuditPage,
  CostCentersPage,
  BalancePage,
  ClassifiedExpensePage,
  ConfigEstadoResultadoPage,
  YearlyComparisonPage,
  CostosSubaplicadosPage,
  MayorCuentasPage,
  IntercompanyCuentasPage,
};